export const content = {
  nav: [
    // SSR fallback nav — must match DB site_content.nav_item rows that are
    // is_visible=true, otherwise the navbar text/items flicker between SSR
    // and client hydration. Source of truth is the DB; this list is only
    // used when the DB fetch hasn't resolved yet.
    { label: "所有圖案", href: "/" },
    { label: "預約 & Q&A", href: "/booking" },
    { label: "購買須知", href: "/overseas" },
    { label: "關於咪室", href: "/about" },
    { label: "歌曲藝廊", href: "/song-gallery" },
    { label: "CATch", href: "/catch" },
    { label: "紋身貼紙", href: "/stickers" },
    { label: "刺青指南", href: "/blog" },
  ],
  brand: {
    name: "咪室刺青",
    nameEn: "MEOWMI TATTOO",
    slogan: "給自己畫一個笑臉",
    location: "台南",
    locationIntl: "台南 · Melbourne",
    ig: "mimimeowtattoo",
    igUrl: "https://www.instagram.com/mimimeowtattoo",
    lineId: "",
  },
  hero: {
    title: "每一筆，都是送給自己的禮物",
    subtitle: "插畫刺青 · 認領圖 · 海外可購買設計",
    infoPills: [
      { icon: "calendar", label: "台南 5月預約中", href: "/booking" },
      { icon: "plane", label: "Melbourne MAY", href: "/booking" },
      {
        icon: "artist",
        label: "Artist @amyowcy",
        href: "https://www.instagram.com/amyowcy?igsh=cnFxaWQ4eGV6bmZk",
      },
      {
        icon: "shop",
        label: "周邊商品",
        href: "https://www.instagram.com/catch___official?igsh=d2IyZ3pmN29oanhp",
      },
    ],
  },
  gallery: {
    title: "認領一張你喜歡的",
    filterAll: "全部",
    filters: [
      "小動物系列",
      "恐龍系列",
      "感受心情系列",
      "搞怪系列",
      "海底動物系列",
      "蠟筆系列",
      "外星系列",
    ],
    availableLabel: "線上購圖", // 2026-10 後台可改:作品卡徽章(artwork_available_badge)
    claimedLabel: "已被帶走了 ♡",
    claimButton: "加入購物車",
    claimedButton: "已被帶走了",
    pricePrefix: "NT$",
    suggestedPosition: "適合部位",
  },
  process: {
    title: "從紙上到皮膚",
    subtitle: "每張認領圖都會變成只屬於你的刺青",
  },
  about: {
    title: "關於咪室",
    bio: "嗨，我是 Amy，在台南開了一間小小的刺青工作室。\n我喜歡畫讓人看了會笑的圖，然後把它們變成大家身上的小故事。\n每一筆線條都是手繪的溫度，每一張認領圖都只給一個人。",
    bookingNote: "預約刺青請 IG 私訊或 LINE 聯繫",
  },
  pricing: {
    flash: "NT$4,000",
    flashNote: "認領圖優惠價，尺寸 5-7 公分，顏色可討論",
    custom: "NT$5,000 起",
    customNote: "客製化刺青，依複雜度報價",
    size: "5-7 公分",
  },
  customSong: {
    title: "客製歌曲刺青",
    intro:
      "如果把最愛的那首歌刺在身上，是什麼模樣？每一首歌在腦海裡都是有圖像的，浪漫得把聽覺變成視覺。",
    methods: [
      {
        label: "自由發揮",
        desc: "完全沒有想法可以讓我自由發揮，提供黑線或彩色、尺寸或部位即可",
      },
      {
        label: "指定元素",
        desc: "指定元素（如火元素、星星等），提供黑線或彩色、尺寸或部位，可附圖片輔助",
      },
    ],
    note: "限一首歌一個圖，歐美、日韓皆可",
  },
  overseas: {
    title: "Overseas Purchase",
    description:
      "Design files available for international clients.\nEach design is one-of-a-kind — once claimed, it's yours only.",
    process: "Browse → Claim → Pay → Receive high-res file via email",
    note: "For personal tattoo use only. Not for commercial reproduction.",
    payment: "PayPal 支付，需預付全額",
  },
  footer: {
    cta: "想刺青？從這裡開始",
    ctaNote: "預約刺青請 IG 私訊",
    copyright: "© 咪室刺青 MEOWMI TATTOO",
    booking: {
      title: "預約資訊",
      items: [
        "台南 & Melbourne 預約中",
        "認領圖 NT$4,000 起",
        "客製刺青 NT$5,000 起",
        "尺寸約 5-7 公分",
      ],
    },
    services: {
      title: "服務項目",
      items: [
        { label: "認領圖藝廊", href: "/" },
        { label: "客製刺青", href: "/custom" },
        { label: "歌曲客製", href: "/custom" },
        { label: "海外購買設計", href: "/overseas" },
        { label: "刺青 Q&A", href: "/faq" },
        { label: "歌曲藝廊", href: "/song-gallery" },
        { label: "CATch 周邊", href: "/catch" },
      ],
    },
    social: {
      title: "找到我們",
      links: [
        {
          label: "@mimimeowtattoo",
          href: "https://www.instagram.com/mimimeowtattoo",
          icon: "ig",
        },
        {
          label: "Artist @amyowcy",
          href: "https://www.instagram.com/amyowcy?igsh=cnFxaWQ4eGV6bmZk",
          icon: "ig",
        },
        {
          label: "周邊 @catch__official",
          href: "https://www.instagram.com/catch___official?igsh=d2IyZ3pmN29oanhp",
          icon: "ig",
        },
      ],
    },
  },
  admin: {
    title: "咪室後台",
    statsTotal: "全部作品",
    statsAvailable: "可認領",
    statsClaimed: "已認領",
    uploadTitle: "上傳新作品",
    uploadDragHint: "拖曳圖片到這裡，或點擊選擇",
    uploadExport: "匯出檔案",
    uploadAdd: "加入藝廊",
    managementTitle: "管理作品",
  },
};
